import { Prefs } from "~/alias/prefs";
import { License } from "~/picreplacement/check";
export async function getFacts() {
    await Prefs.untilLoaded;
    await License.ready();
    return {
        hasPremium: License.isActiveLicense(),
        installDate: Prefs.get("installDate"),
        blockedCount: Prefs.get("blocked_total"),
    };
}
